import Loader from '@/components/Loader'
import { useState, createContext } from 'react'

interface ILoading {
  children: React.ReactNode
}

type LoadingContextData = {
  LOADING: any
  SET_LOADING: (isLoading: boolean) => void
}

export const LoadingContext = createContext({} as LoadingContextData)

export function LoadingProvider({ children }: ILoading) {
  const [LOADING, SET_LOADING] = useState(false)

  return (
    <LoadingContext.Provider
      value={{
        LOADING,
        SET_LOADING
      }}
    >
      <Loader type="page" inLoading={LOADING} />
      {children}
    </LoadingContext.Provider>
  )
}
